/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from '../request.js'

// 获取联通随享订单列表
export function ltshareList(params) {
    return request({
        url: 'ltshare/list.do?',
        method: 'post',
        data: params
    })
}

// 导出联通随享订单
export function ltshareExport(params) {
    return request({
        url: 'ltshare/export.do?',
        method: 'post',
        data: params
    })
} 